
//import React from 'react';
//import Table from './components/Table';

import React, { Component } from "react";
import { render } from "react-dom";
import moment from 'moment';

import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { CSVLink, CSVDownload } from "react-csv";


class ResultsTable2 extends Component {
  constructor(props) {
    super(props);

	document.title = this.props.theevent.name + " results";
	
}

render() {
	if (this.props.page == "-1")
	{
  return(
    <div className="ResultsTable">
	<h1>{this.props.theevent.name} - {moment(this.props.theevent.event_date).format('DD/MM/YYYY')}</h1>
	<CSVLink data={this.props.results} filename={this.props.theevent.name + ".csv"}>Download as csv</CSVLink>
	<br /><br />


	<div 
        className="ag-theme-balham"
        style={{ 
        height: '500px', 
        width: '100%' }} 
      >
		
		
		<ReactTable
			data={this.props.results}
			columns={this.props.checkpoints}
			defaultSorted={this.props.sortorder}
			showPagination={true}
			pageSize={100}
			minRows={0}
		/>

      </div>
    </div>
  );	
	}
	else
	{
  return(
    <div className="ResultsTable">
	<h1>{this.props.theevent.name} - {moment(this.props.theevent.event_date).format('DD/MM/YYYY')}</h1>
	<br />


	<div 
        className="ag-theme-balham"
        style={{ 
        height: '500px', 
        width: '100%' }} 
      >
		
		
		<ReactTable
			data={this.props.results}
			columns={this.props.checkpoints}
			defaultSorted={this.props.sortorder}
			showPagination={true}
			page={this.props.page}
			pageSize={100}
			minRows={0}
		/>

      </div>
    </div>
  );	
		
	}
}

}
  
export default ResultsTable2;
